/**
 * @mixin
 * @description Esse mixins responsável pelas sombras e animações do scroll interno das abas. 
 * @requires {@link BusinessPlanCore} requer o mixin base para o `currentStep`.
 * @example
 * mixins: [BusinessPlanScroll]
 */
export default {
  data() {
    return {
      /** @type {HTMLDivElement} */
      activeItemElement: null,
      shadowHeader: false,
      shadowFooter: false
    };
  },
  /**
   * Inicia o event listener do scroll dentro de uma aba, logo após a renderização dos componentes.
   */
  mounted() {
    setTimeout(this.updateScrollListener, 100);
  },
  /**
   * Apaga o event listener antes da destruição do componente da página em si.
   */
  beforeDestroy() {
    if (this.activeItemElement) {
      this.activeItemElement.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    /**
     * Calcula a posição do scroll relativo ao topo e a base da aba, indicando onde deve exibir um efeito de sombreamento na aba.
     */
    handleScroll() {
      if (!this.activeItemElement) {
        return;
      }

      this.shadowFooter =
        this.activeItemElement.scrollTop +
          this.activeItemElement.clientHeight <=
        this.activeItemElement.scrollHeight - 1;
      this.shadowHeader = this.activeItemElement.scrollTop > 0;
    },
    /**
     * Atualiza o event listener para a aba ativa.
     * Caso já tenha um event listener na aba anterior, o destroí.
     */
    updateScrollListener() {
      if (this.activeItemElement) {
        this.activeItemElement.removeEventListener("scroll", this.handleScroll);
      }

      this.activeItemElement = this.$el.querySelector(
        ".tab-container + .v-window.v-item-group"
      );

      if (this.activeItemElement) {
        this.activeItemElement.addEventListener("scroll", this.handleScroll);
        setTimeout(this.handleScroll, 100);
      }
    }
  },
  watch: {
    /**
     * Watcher para trocar o elemento ativo ao trocar de aba
     */
    currentStep() {
      setTimeout(this.handleScroll, 100);
    }
  }
};
